import React from 'react'
import cn from 'classnames'

export default ({ className, children, actions, qslProps, ...rest }) => {
  return (
    <div {...rest} className={cn('tnt-querylistscene-toolbar', { [className]: className })}>
      {children}
    </div>
  )
}
